if (!customElements.get('fenlux-concept')) {
  customElements.define('fenlux-concept', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.setupSurvey();
      const slides = [...this.querySelectorAll('[data-slide]')];
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      const position = this.querySelector('[data-position]');
      const dialog = this.querySelector('[data-image-dialog]');
      let current = 0;
      const select = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === current)));
        if (position) position.textContent = (current + 1) + ' / ' + slides.length;
      };
      this.querySelectorAll('[data-gallery-controls]').forEach(el => { el.hidden = false; });
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));
      this.querySelector('[data-prev]')?.addEventListener('click', () => select(current - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => select(current + 1));
      if (dialog && typeof dialog.showModal === 'function') {
        slides.forEach(slide => slide.addEventListener('click', event => {
          event.preventDefault();
          const image = dialog.querySelector('img');
          image.src = slide.href;
          image.alt = slide.querySelector('img').alt;
          dialog.showModal();
        }));
        dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      }
    }
    async setupSurvey() {
      const q = selector => this.querySelector(selector);
      const radios = [...this.querySelectorAll('[data-reaction]')];
      const status = q('[data-response-status]');
      const commentForm = q('[data-comment-form]'), commentStatus = q('[data-comment-status]');
      const priceForm = q('[data-price-form]'), priceStatus = q('[data-price-status]');
      const priceOpen = q('[data-price-open]'), priceDialog = q('[data-price-dialog]');
      if (!this.dataset.interestEndpoint) { status.textContent = 'Feedback collection is not open yet.'; return; }
      let visitor;
      try {
        visitor = localStorage.getItem('fenlux-concept-visitor-v1');
        if (!/^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(visitor || '')) {
          visitor = crypto.randomUUID(); localStorage.setItem('fenlux-concept-visitor-v1',visitor);
        }
      } catch { status.textContent = 'Please allow browser storage to save your response.'; return; }
      const send = async (action,extra = {}) => {
        const controller = new AbortController(), timer = setTimeout(() => controller.abort(),12000);
        try {
          const response = await fetch(this.dataset.interestEndpoint,{method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'application/json'},signal:controller.signal,body:JSON.stringify({action,design:this.dataset.design,version:this.dataset.version,visitor,...extra})});
          const data = await response.json();
          if (!response.ok || (action !== 'status' && data.saved !== true)) throw new Error(data.error || 'Unable to confirm saving. Please try again.');
          return data;
        } finally { clearTimeout(timer); }
      };
      const message = error => error.name === 'AbortError' || error.name === 'TypeError' || error.name === 'SyntaxError' ? 'Unable to confirm saving. Please try again.' : error.message;
      const names = {like:'Like',dislike:'Not for me',neutral:'Neutral'};
      let savedReaction = null, busy = false;
      const paint = reaction => radios.forEach(radio => { radio.checked = radio.value === reaction; });
      const lock = locked => {
        busy = locked; radios.forEach(radio => { radio.disabled = locked; });
        commentForm.querySelector('button').disabled = locked; priceForm.querySelector('button').disabled = locked;
        q('.fx-concept__reactions').setAttribute('aria-busy',String(locked));
      };
      const saveReaction = async reaction => {
        if (busy) return;
        lock(true); status.textContent = 'Saving your choice...';
        try {
          const result = await send('react',{reaction}); savedReaction = result.reaction; paint(savedReaction);
          status.textContent = 'Saved: ' + names[savedReaction] + '. You can change your choice.';
        } catch (error) { paint(savedReaction); status.textContent = message(error); }
        finally { lock(false); }
      };
      radios.forEach(radio => radio.addEventListener('change', () => saveReaction(radio.value)));
      commentForm.addEventListener('submit', async event => {
        event.preventDefault(); if (busy || !commentForm.reportValidity()) return;
        lock(true); commentStatus.textContent = 'Saving your private comment...';
        try {
          await send('comment',{comment:commentForm.elements.comment.value});
          commentStatus.textContent = 'Your private comment has been saved for the FENLUX team.';
        } catch (error) { commentStatus.textContent = message(error); } finally { lock(false); }
      });
      priceOpen.addEventListener('click', () => { priceStatus.textContent = ''; priceDialog.showModal(); });
      q('[data-price-close]').addEventListener('click', () => priceDialog.close());
      priceDialog.addEventListener('click', event => { if (event.target === priceDialog) priceDialog.close(); });
      priceForm.addEventListener('submit', async event => {
        event.preventDefault(); if (busy || !priceForm.reportValidity()) return;
        lock(true); priceStatus.textContent = 'Saving your price update request...';
        try {
          await send('lead',{full_name:priceForm.elements.full_name.value,email:priceForm.elements.email.value,consent:priceForm.elements.consent.checked});
          priceStatus.textContent = 'Thank you. Your request has been saved. We can email you when pricing is available.';
          q('[data-price-note]').textContent = 'Your price update request has been saved.'; priceForm.reset();
        } catch (error) { priceStatus.textContent = message(error); } finally { lock(false); }
      });
      lock(true);
      try {
        const data = await send('status'); savedReaction = names[data.reaction] ? data.reaction : null; paint(savedReaction);
        status.textContent = savedReaction ? 'Saved: ' + names[savedReaction] + '. You can change your choice.' : 'Select the response that best matches how you feel.';
        if (data.comment_saved) commentStatus.textContent = 'You have already left a private comment. Submitting again replaces it.';
        if (data.price_requested) q('[data-price-note]').textContent = 'Your price update request has been saved.';
      } catch { status.textContent = 'Unable to check your saved response. Choose an option to try again.'; }
      finally { lock(false); priceOpen.disabled = false; }
    }
  });
}
